import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../actionTypes';

const initialState = false;

const isLoading = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.FETCH_APPOINTMENTS_REQUEST]: isLoading,
  [actionTypes.FETCH_APPOINTMENTS_SUCCESS]: isEnding,
  [actionTypes.FETCH_APPOINTMENTS_FAILURE]: isEnding,
  [actionTypes.FETCH_APPOINTMENT_REQUEST]: isLoading,
  [actionTypes.FETCH_APPOINTMENT_SUCCESS]: isEnding,
  [actionTypes.FETCH_APPOINTMENT_FAILURE]: isEnding,
  [actionTypes.DELETE_REQUEST]: isLoading,
  [actionTypes.DELETE_SUCCESS]: isEnding,
  [actionTypes.DELETE_FAILURE]: isEnding,
  [actionTypes.PATCH_STATUS_REQUEST]: isLoading,
  [actionTypes.PATCH_STATUS_SUCCESS]: isEnding,
  [actionTypes.PATCH_STATUS_FAILURE]: isEnding,
  [actionTypes.POST_REQUEST]: isLoading,
  [actionTypes.POST_SUCCESS]: isEnding,
  [actionTypes.POST_FAILURE]: isEnding,
  [actionTypes.PUT_REQUEST]: isLoading,
  [actionTypes.PUT_SUCCESS]: isEnding,
  [actionTypes.PUT_FAILURE]: isEnding,
});
